// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3ONv7","amount":"Amount_amount__2R7vT","tip":"Amount_tip__36xTd","tipHeader":"Amount_tipHeader__Imr9C","tipsWrap":"Amount_tipsWrap__2g9UG"};